// src/i18n/lists.ts —— 06 agent-portal A-03～A-06 [新增 key] / [改写 key]；06 未给英文者标「本计划定稿」（待回写 06）
export const I18N_LISTS = {
  zh: {
    stKycNone: '未认证',
    stKycRejected: '已拒绝',
    unitCard: '张',
    stAuthorize: '授权中',
    stAuthDel: '授权撤销',
    stRefundCancel: '退款撤销',
    stDispute: '争议中',
    stTxUnknown: '未知',
    direct: '直推', // 原型内联文案（lang==='zh'?'直推':'Direct'）键化
    tgUser: 'TG 用户', // 06 A-04「无邮箱显示 TG 用户」
    typeOpen: '开卡差价', // [改写 key] 0045（旧返佣记录同 kind，文案统一）
    typeSpend: '充值差价', // [改写 key] D10 / 0045
    typeFXSpread: '汇率差',
    tabComm: ['全部', '待结算', '已结算', '开卡差价', '充值差价', '汇率差'], // [改写 key] 0045
  },
  en: {
    stKycNone: 'Not verified',
    stKycRejected: 'Rejected',
    unitCard: 'card',
    stAuthorize: 'Authorizing', // 本计划定稿
    stAuthDel: 'Auth reversed', // 本计划定稿
    stRefundCancel: 'Refund reversed', // 本计划定稿
    stDispute: 'Disputed', // 本计划定稿
    stTxUnknown: 'Unknown', // 本计划定稿
    direct: 'Direct',
    tgUser: 'TG user', // 本计划定稿
    typeOpen: 'Card markup',
    typeSpend: 'Top-up markup',
    typeFXSpread: 'FX spread',
    tabComm: ['All', 'Unsettled', 'Settled', 'Card markup', 'Top-up markup', 'FX spread'],
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值
export const REWRITES_LISTS: readonly string[] = ['typeOpen', 'typeSpend', 'tabComm'];
